import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const { isSmid, merchantList } = data
  const activeMidsList =
    merchantList
      ?.filter((item: any) => item?.status?.toLowerCase() === 'active')
      .map((item) => {
        if (!item.businessName) {
          return { ...item, businessName: 'NA' }
        }
        return item
      }) ?? []
  return { isSmid: isSmid, midList: activeMidsList }
}

const getSubMerchantsWithMid = (mid: string, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.isSuperMerchant,
    body: {
      entityId: mid,
    },
    method: 'POST',
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { getSubMerchantsWithMid }
